new Swiper(".mySwiper", {
  slidesPerView: 1,
  loop: !0,
  spaceBetween: 5,
  autoplay: { delay: 9e3, disableOnInteraction: !1 },
  navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" },
});


function showTab(tabName) {
  // Hide all tabs
  const allTabs = document.querySelectorAll('.tab-pane');
  allTabs.forEach(tab => tab.classList.remove('active'));

  // Remove active class from all buttons
  const allButtons = document.querySelectorAll('.tab-btn');
  allButtons.forEach(button => button.classList.remove('active'));

  // Show the selected tab and set the button to active
  document.getElementById(tabName).classList.add('active');
  const activeButton = document.querySelector(`.tab-btn[onclick="showTab('${tabName}')"]`);
  activeButton.classList.add('active');
}
// tab pills js end



// accordina js start
var acc = document.getElementsByClassName("accordion");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.display === "block") {
      panel.style.display = "none";
    } else {
      panel.style.display = "block";
    }
  });
}

// url tab

document.addEventListener("DOMContentLoaded", function() {
                // Get the current URL
                const currentUrl = window.location.href;
            
                // Get all filter links
                const filterLinks = document.querySelectorAll(".filtertab");
            
                // Loop through all filter links
                filterLinks.forEach(function(link) {
                  // Check if the link href is part of the current URL
                  if (currentUrl.includes(link.getAttribute("href").split("#")[0])) {
                    // Add the "active" class to the matching link
                    link.classList.add("active");
                  }
                });
              });

// collection and PDp accordina


  window.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.accordion-tab').forEach(function(btn) {
      btn.addEventListener('click', function() {
        // toggle the +/- icon
        this.classList.toggle('active');

        // grab the next sibling .panel
        var panel = this.nextElementSibling;

        if (panel.style.maxHeight) {
          // panel is open → close it
          panel.style.maxHeight = null;
        } else {
          // panel is closed → open to its scrollHeight
          panel.style.maxHeight = panel.scrollHeight + 'px';
        }
      });
    });
  });



  // customer timer js

  // const targetDate = new Date("October 10, 2025 23:59:00").getTime();

  // function updateTimer() {
  //   const now = new Date().getTime();
  //   const diff = targetDate - now;

  //   if (diff < 0) {
  //     document.getElementById('days').textContent = '00';
  //     document.getElementById('hours').textContent = '00';
  //     document.getElementById('minutes').textContent = '00';
  //     document.getElementById('seconds').textContent = '00';
  //     return;
  //   }

  //   const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  //   const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  //   const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
  //   const seconds = Math.floor((diff % (1000 * 60)) / 1000);

  //   document.getElementById('days').textContent = days.toString().padStart(2, '0');
  //   document.getElementById('hours').textContent = hours.toString().padStart(2, '0');
  //   document.getElementById('minutes').textContent = minutes.toString().padStart(2, '0');

  //   const secondsEl = document.getElementById('seconds');
  //   const currentSeconds = secondsEl.textContent;
  //   const newSeconds = seconds.toString().padStart(2, '0');

  //   if (currentSeconds !== newSeconds) {
  //     secondsEl.classList.remove('flip');
  //     void secondsEl.offsetWidth; // trigger reflow to restart animation
  //     secondsEl.textContent = newSeconds;
  //     secondsEl.classList.add('flip');
  //   }
  // }

  // setInterval(updateTimer, 1000);
  // updateTimer(); // initial call
